import { WebTracerProvider, SimpleSpanProcessor } from '@opentelemetry/sdk-trace-web';
import { registerInstrumentations } from '@opentelemetry/instrumentation';
import { DocumentLoadInstrumentation } from '@opentelemetry/instrumentation-document-load';
import { FetchInstrumentation } from '@opentelemetry/instrumentation-fetch';
import { XMLHttpRequestInstrumentation } from '@opentelemetry/instrumentation-xml-http-request';
import { ATTR_SERVICE_NAME } from '@opentelemetry/semantic-conventions';
import { resourceFromAttributes } from '@opentelemetry/resources';

import { ZoneContextManager } from '@opentelemetry/context-zone';
import { OTLPTraceExporter } from '@opentelemetry/exporter-trace-otlp-proto';
declare global {
    interface Window {
        app_env: string;
        sentryProKey: string;
        sentryProId: string;
        otlpHTTPEndpoint: string;
        otlpGRPCEndpoint: string;
        enableOtlpWebExporter: string;
    }
}
const endpoint = window.otlpHTTPEndpoint || 'http://localhost:4318';

const exporter = new OTLPTraceExporter({
    url: `${endpoint}/v1/traces`,
});

const resource = resourceFromAttributes({
    [ATTR_SERVICE_NAME]: 'crm-sales-web',
});

const provider = new WebTracerProvider({
    resource,
    spanProcessors: window.enableOtlpWebExporter ? [new SimpleSpanProcessor(exporter)] : null,
});

provider.register({
    contextManager: new ZoneContextManager(),
});

registerInstrumentations({
    instrumentations: [
        new DocumentLoadInstrumentation(),
        new FetchInstrumentation(),
        new XMLHttpRequestInstrumentation(),
    ],
});
